export default __webpack_public_path__ + "static/media/one_to_one.f469b7de.svg";